var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Watch, Mixins } from 'vue-property-decorator';
import BaseTableFilterMixin from './baseFilterMixin';
import { normalize, DateAccuracy } from '@core/helper/date-time';
var DateTimeFilter = /** @class */ (function (_super) {
    __extends(DateTimeFilter, _super);
    function DateTimeFilter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.accuracy = DateAccuracy.DateTime;
        _this.start = '';
        _this.end = '';
        return _this;
    }
    DateTimeFilter.prototype.onValueChanged = function () {
        var _a;
        _a = this.value, this.start = _a[0], this.end = _a[1];
    };
    DateTimeFilter.prototype.onStartOrEndChanged = function () {
        this.value = [this.start, this.end];
    };
    DateTimeFilter.prototype.mounted = function () {
        this.onValueChanged();
    };
    DateTimeFilter.prototype.data = function () {
        return {
            accuracy: this.options != null && this.options.accuracy != null ? this.options.accuracy : DateAccuracy.DateTime,
        };
    };
    DateTimeFilter.prototype.filter = function () {
        var _a;
        var _this = this;
        this.isLoading = true;
        var query = (_a = {},
            _a[this.queryName] = this.value.map(function (o) { return o == null ? '' : o; }).join(','),
            _a);
        this.$emit('filter', query, function () {
            _this.isLoading = false;
        });
    };
    DateTimeFilter.prototype.resetToDefault = function () {
        var _this = this;
        this.reset();
        this.$nextTick(function () {
            _this.reset();
        });
    };
    Object.defineProperty(DateTimeFilter.prototype, "isValueDefault", {
        get: function () {
            var _this = this;
            // use normalize to compare so that accuracy is the same, currently resetting to default twice fixes it
            var normalizedValues = this.value.map(function (o) { return normalize(o, _this.accuracy).getTime(); });
            var normalizedDefaults = this.defaultValue.map(function (o) { return normalize(o, _this.accuracy).getTime(); });
            return normalizedValues.every(function (o) { return normalizedDefaults.indexOf(o) != -1; });
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Watch('value')
    ], DateTimeFilter.prototype, "onValueChanged", null);
    __decorate([
        Watch('start'),
        Watch('end')
    ], DateTimeFilter.prototype, "onStartOrEndChanged", null);
    DateTimeFilter = __decorate([
        Component({
            components: {},
        })
    ], DateTimeFilter);
    return DateTimeFilter;
}(Mixins(
// Mixin constructors go here
BaseTableFilterMixin)));
export default DateTimeFilter;
